import { withFormik } from 'formik'
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose'

import {required, passwordIsInvalid, samePassword} from 'utils/validation'
import {FORM_ACTION_ERROR_STATUS, FORM_PROGRESS_STATUS, FORM_SUBMIT_STATUS} from 'constants/form'


export default compose(
  withFormik({
    // Transform outer props into form values
    mapPropsToValues: () => ({ oldPassword: '', newPassword: '', confirmPassword: '' }),
    // Add a custom validation function (this can be async too!)
    validate: ({ oldPassword, newPassword, confirmPassword }) => {
      const errors = {}

      if (required(oldPassword)) {
        errors.oldPassword = 'Please enter a password'
      }

      if (required(newPassword) || passwordIsInvalid(newPassword)) {
        errors.newPassword = 'Your password must have a minimum of eight characters.'
      }
      else if (!samePassword(oldPassword, newPassword)) {
        errors.newPassword = 'This password must be different from your old one'
      }

      if (required(confirmPassword)) {
        errors.confirmPassword = 'Please enter a confirmation password'
      }
      else if (samePassword(newPassword, confirmPassword)) {
        errors.confirmPassword = 'This password does not match'
      }

      return errors
    },
    enableReinitialize: true,
    validateOnChange: false,
    handleSubmit: (values, {
      props, setSubmitting,
    }) => {
      setSubmitting(true)
      // If form has no error
      if (props.onPasswordSubmit) {
        props.onPasswordSubmit(values)
      }
    // props.actions.loginUser(values)
    },
  }),
  withStateHandlers(
    () => ({
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
    }),
    {
      toggleOldPasswordVisibility: state => () => ({
        showOldPassword: !state.showOldPassword
      }),
      toggleNewPasswordVisibility: state => () => ({
        showNewPassword: !state.showNewPassword
      }),
      toggleConfirmPasswordVisibility: state => () => ({
        showConfirmPassword: !state.showConfirmPassword
      })
    }
  ),
  // Handlers
  withHandlers({
    handleFieldChange: props => (event) => {
    // test
      props.setStatus(FORM_PROGRESS_STATUS)
      props.handleChange(event)
    },
    handleFormSubmit: props => (event) => {
      props.setStatus(FORM_SUBMIT_STATUS)
      props.handleSubmit(event)
    },
    hasFieldError: props => (fieldName) => {
      return !!((props.errors[fieldName] && props.errors[fieldName].length && props.status === FORM_SUBMIT_STATUS))
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        apiCallError, setStatus, setSubmitting
      } = this.props
      // trigger when error occured during login
      if (prevProps.apiCallError !== apiCallError && apiCallError) {
        setStatus(FORM_ACTION_ERROR_STATUS)
        setSubmitting(false)
      }
    },

  })
)




// WEBPACK FOOTER //
// ./src/components/organisms/ChangePasswordForm/ChangePasswordForm.enhancer.js